import React, { Component } from 'react';
import { format } from "date-fns";
import { Big3Common } from '../../js/IncludeManager'
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from 'swiper';
import "swiper/css";
import 'swiper/css/pagination';
import Lottie from "lottie-react";

/* 개발담당:이재호
 * 화면기능:메인 팝업
 * 세부설명:
*/

export class PopupAd extends Component {
    static displayName = PopupAd.name;

    constructor(props) {

        super(props);
        this.state = {
            PopupAdList: [],
            NottieData: "",
            ShowPopup: true
        };
        this.VirtualRoot = Big3Common.WebConfig.EventImageVirtualPath();
        this.storedDate = Big3Common.WebStorage.GetLocalStorage("PopupAd");
        this.toDay = format(Big3Common.Util.DateAdd(new Date(), 0), "yyyy-MM-dd");
        if (this.storedDate === this.toDay) {
            this.state.ShowPopup = false;
        }
        this.handleTodayClose_Click = this.handleTodayClose_Click.bind(this);
        this.Uid_Type = Big3Common.WebStorage.GetLocalStorage(Big3Common.WebStorage.StorageName.Uid_Type)
    }
    //초기화
    async componentDidMount() {
        await this.GetPopup();
    }
    //팝업 리스트 가져오기
    async GetPopup() {
        try {
            Big3Common.Util.LoadingOn();
            const Data = await Big3Common.Post('api/AdMgr/PopupAd/GetPopup', { uid_type: this.Uid_Type });
            if (Data.codeName === Big3Common.ResultCode.Success) {
                const PopupAdList = JSON.parse(Data.dataTable);
                this.setState({
                    PopupAdList: PopupAdList,
                });
                if (this.state.ShowPopup === true && PopupAdList.length > 0) {
                    document.body.style.overflow = 'hidden';
                }
                if (PopupAdList.length > 0) {
                    const NottieList = PopupAdList.filter(list => list.extension.toLowerCase() === "json");
                    if (NottieList.length > 0) {
                        await this.GetNottieData(NottieList[0]);
                    }
                }
            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("GetPopup", e);
        }
        finally {
            Big3Common.Util.LoadingOff();
        }
    }
    //오늘 그만보기
    handleTodayClose_Click = (event) => {
        Big3Common.WebStorage.SetLocalStorage("PopupAd", this.toDay);
        const popupClose = document.getElementById(this.props.id);
        const backdrop = document.getElementById('backdrop');
        if (popupClose) {
            popupClose.classList.add('bs_popup_close');
            backdrop.classList.add('bs_popup_bg_close');
        }
        setTimeout(() => {
            this.setState({ ShowPopup: false });
        }, 450);
        document.body.style.overflow = 'auto';
        event.preventDefault();
    }
    //닫기
    handleCloseClick = (event) => {
        const popupClose = document.getElementById(this.props.id);
        const backdrop = document.getElementById('backdrop');
        if (popupClose) {
            popupClose.classList.add('bs_popup_close');
            backdrop.classList.add('bs_popup_bg_close');
        }
        setTimeout(() => {
            this.setState({ ShowPopup: false });
        }, 450);
        document.body.style.overflow = 'auto';
        event.preventDefault();
    }
    //팝업 클릭시 링크url로 전환
    handle_Location = (event, link_url) => {
        window.open(link_url, "_blank");
        event.preventDefault();
    }
    handle_innerLocation() {
        document.body.style.overflow = 'auto';
    }
    //Nottie 이미지 가져오기
    GetNottieData = async (list) => {
        await fetch(`${this.VirtualRoot}/${list.file_path}`)
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok ' + response.statusText);
                }
                return response.json();
            })
            .then(data => {
                this.setState({
                    NottieData: data
                });
                return data;

            })
            .catch(error => {
                console.error('There was a problem with the fetch operation:', error);
            })
    }
    BannderRender = (list) => {
       
        if (list.extension.toLowerCase() === "json") {
            return (
                <Lottie animationData={this.state.NottieData} />
            )
        }
        else if (list.link_type_cd === "OL") {
            return (
                <img src={`${this.VirtualRoot}/${list.file_path}`} alt="" onClick={(e) => { this.handle_Location(e, list.link_url) }} />
            )
        }
        else if (list.link_type_cd === "NO") {
            return (
                <img src={`${this.VirtualRoot}/${list.file_path}`} alt="" />
            )
        }
        else {
            return (
                <Link to={list.link_url} onClick={() => { this.handle_innerLocation() }}>
                    <img src={`${this.VirtualRoot}/${list.file_path}`} alt="" />
                </Link>
            )
        }
    }

    render() {
        const ShowPopup = this.state.ShowPopup
        const PopupAdList = this.state.PopupAdList
        const slidersCount = 1;

        if (!ShowPopup || PopupAdList.length === 0) {
            return null
        }
        return (
            <div className="bs_popup_bg" id={"backdrop"} tabIndex="-1" aria-labelledby="exampleModalLabel">
                <div className="bs_popup_up" >
                    <div className="bs_popup" id={this.props.id}>
                        <Swiper className="bs_popup_img"
                            watchSlidesProgress={true}
                            slidesPerView={slidersCount}
                            autoplay={{ delay: 2000, disableOnInteraction: false }}  // 밀리초 단위로 딜레이 설정
                            modules={[Autoplay, Pagination]}
                        >
                            <div>
                                {
                                    PopupAdList.map((list, idx) =>
                                        <SwiperSlide key={idx}>
                                            {this.BannderRender(list)}
                                            <div className="banner_page_number">
                                                <div>{idx + 1}</div>
                                                <div>/</div>
                                                <div>{PopupAdList.length}</div>
                                            </div>
                                        </SwiperSlide>
                                    )
                                }
                            </div>
                        </Swiper>
                        <div className="bs_popup_footer">
                            <div className="bs_popup_footer_ios">
                                <button type="button" className="today_close" onClick={this.handleTodayClose_Click} >오늘 그만보기</button>
                                <button type="button" className="close" onClick={this.handleCloseClick}>닫기</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
